var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoPlayerSport = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ball",
    transform: "translate(-16.416)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29041",
    "data-name": "Group 29041",
    transform: "translate(16.416)",
    fill: "#00a1af"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48233",
    "data-name": "Path 48233",
    d: "M16.681,134.4c-.433.357-.325.579.239.492a33.89,33.89,0,0,0,7.895-2c1.725-.847,2.332.305,1.755,1.191-.215.333-.071.513.318.411,2.221-.588,6.946-2.054,8.219-6.533.058-.2.076-.666-.1-.8l-.073-.053a6.7,6.7,0,0,1-4.055,2.4,8.668,8.668,0,0,1-4.887-.408,7.308,7.308,0,0,1-2.36-1.594,7.814,7.814,0,0,1-1.6-8.331,7.326,7.326,0,0,1,.724-1.279l-.063-.045c-.194-.141-.792.05-.972.208-1.024.9-4.031,4.148-4.739,11.81-.034.377.2.513.531.3a1.152,1.152,0,0,1,1.464-.071C19.628,130.721,18.27,133.091,16.681,134.4Z",
    transform: "translate(-16.416 -114.913)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48234",
    "data-name": "Path 48234",
    d: "M268.713,14.179a7.074,7.074,0,1,0-5.018-2.072,7.09,7.09,0,0,0,5.018,2.072ZM275.1,7.71l.009.008a6.371,6.371,0,0,1-.475,1.87q-.123.291-.273.567h-.013l-1.853.276-.721.112L270.591,9l-.031-.04.773-2.381,1.865-.612Zm-6.061-5.242,2.253-1.261.011-.007a6.41,6.41,0,0,1,1.953,1.341q.123.123.239.253V2.8l-.5,2.53-1.929.634-2.028-1.474V2.473Zm1.065,6.976,1.161,1.513-1.006,2.358v.012a6.481,6.481,0,0,1-3.1,0v-.012l-1.006-2.358,1.161-1.513Zm-5.94-6.9A6.41,6.41,0,0,1,266.12,1.2l.011.007,2.253,1.261V4.494l-1.915,1.391-.112.082-1.929-.634-.223-1.16-.269-1.368V2.794A3.3,3.3,0,0,1,264.167,2.543Zm-1.105,7.616a6.282,6.282,0,0,1-.273-.566,6.368,6.368,0,0,1-.475-1.87l.009-.008,1.9-1.752,1.865.612.773,2.381-1.218,1.587-2.57-.383Z",
    transform: "translate(-255.802)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoPlayerSport);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_player_sport.86d70f49713e73c0f8f9dc76a15ba2c8.svg";